import script from "./AidCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./AidCard.vue?vue&type=script&setup=true&lang=ts"

import "./AidCard.vue?vue&type=style&index=0&id=70d5a1df&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70d5a1df"]])

export default __exports__